module.exports = __webpack_public_path__ + "static/media/art2.2f2c9fb3.jpg";